/**
* @description: 提交记录列表
*/
<template>
    <div class="finance_box" ref="myElementRef">
        <div ref="searchBox">
            <hc-search :data="searchData" @serch="getSearch" />
        </div>
        <!-- 表格 -->
        <div class="table_box">
            <hc-table :tableData="state.tableData" :column="state.tableHeader" :offsetHeight="state.offsetHeight" :maxPage="maxPage" :loading="state.loading"
                @pageChange="pageChange" @limitChange="limitChange">
                <template #material_url="{ row }">
                    <hc-oss-image-list :value="row.material_url" />
                </template>
                <template #status="{ row }">
                    {{ listToMap(statusOptions, {})[row.status] }}
                </template>
                <template #operation="scope">
                    <div class="btn_box_det">
                        <el-button  class="opBtn" v-if="scope.row.status === 2" size="small" type="primary" link
                            @click="openAudit(scope.row)">{{ t('taskSpecial.auditTask') }}</el-button>
                        <el-button  class="opBtn" v-if="scope.row.status > 2" size="small" type="primary" link
                            @click="openDetail(scope.row)">{{ t('common.detail') }}</el-button>
                    </div>
                </template>
            </hc-table>
        </div>
        <!-- 新增 -->
        <!-- 审核 -->
        <Audit ref="audit" :title="t('taskSpecial.auditTask')" @refresh="getSearch(searchData)" />

        <!-- 详情 -->
        <Detail ref="detail" />
    </div>
</template>

<script setup>
import hcSearch from "@/components/hc-search/index.vue";
import hcTable from "@/components/hc-table/index.vue";
import { onMounted, reactive, ref, nextTick, onUnmounted, onActivated, toRaw } from "vue";
import Audit from "./components/audit.vue";
import Detail from "./components/detail.vue"

import { pageListApi as taskListApi } from "@/api/improve/improve.js";
import { pageListApi } from "@/api/improve/record.js";
import { listToMap } from "@/utils/utils";
import { usePageI18n } from "@/composables/usePageI18n.js";
import { applyImproveSubmitLabels } from "@/utils/taskSubmitI18n.js";
const myElementRef = ref();
const searchBox = ref();
const audit = ref();
const detail = ref();


let page = ref(1);
let limit = ref(20);
let maxPage = ref(0);
const statusOptions = reactive([
    { label: "未提交", value: 0 },
    { label: "进行中", value: 1 },
    { label: "待审核", value: 2 },
    { label: "通过", value: 3 },
    { label: "不通过", value: 4 },
])


const state = reactive({
    title: "",
    column: [
        {
            prop: "id",
            show: false,
            label: "记录ID",
        },
        {
            // prop: "id",
            show: true,
            type: "index",
            label: "序号",
            width: 80,
        },
        {
            prop: "title",
            show: true,
            label: "任务名称",
            width: 300,
        },
        {
            prop: "real_name",
            show: true,
            label: "提交人姓名",
        },
        {
            prop: "score",
            show: true,
            label: "分值",
            width: 60
        },
        {
            prop: "material_url",
            show: true,
            label: "材料",
            width: 200
        },
        {
            prop: "note",
            show: true,
            label: "汇报内容",
        },
        {
            prop: "created_at",
            show: true,
            label: "创建时间",
        },
        {
            prop: "updated_at",
            show: true,
            label: "更新时间",
        },
        {
            prop: "status",
            show: true,
            label: "状态",
            width: 60
        },
        {
            prop: "operation",
            show: true,
            label: "操作",
        },
    ],
    offsetHeight: 0,
    loading: false,
    tableHeader: [],
    tableData: [
        // {
        //     "updated_at": "2025-05-09 15:02:01",
        //     "user_id": 1,
        //     "mobile": "13456214521",
        //     "created_at": "2025-05-09 15:02:01",
        //     "task_id": 1,
        //     "real_name": "张三",
        //     "id": 1,
        //     "replied_by": 0,
        //     "status": 0,
        //     "username": "jishou0001"
        // }
    ]
});

const searchData = reactive([
    {
        label: "状态",
        type: "select",
        children: [
            { label: "全部", value: 0 },
            { label: "待审核", value: 2 },
            { label: "已通过", value: 3 },
            { label: "失败", value: 4 },
        ],
        value: 0,
        field: 'status',
        defaultValue: 0,
        clearable: false
    },
    {
        label: "任务名称/姓名关键词",
        type: "input",
        value: "",
        field: 'keywords'
    },
]);

const applyLabels = () => {
    applyImproveSubmitLabels({ searchData, columns: state.column, statusOptions });
    const sf = searchData.find((s) => s.field === 'status');
    if (sf?.children?.length >= 4) {
        sf.children[0].label = t('common.all');
        sf.children[1].label = t('taskSubmit.statusPending');
        sf.children[2].label = t('improveSubmit.statusPass');
        sf.children[3].label = t('improveSubmit.statusFail');
    }
    searchData[1].label = t('taskSubmit.keywordTaskOrName');
};
const { t } = usePageI18n(applyLabels);

const init = () => {
    getSearch(searchData)
};

// const getTaskList = () => {
//     const requestParams = {
//         "keywords": "",
//         "page": 1,
//         "limit": 9999
//     }
//     taskListApi(JSON.stringify(requestParams)).then(res => {
//         if (res.code == 200) {
//             searchData[0].children = res.data.map(i => {
//                 return {
//                     ...i,
//                     label: i.title,
//                     value: i.id
//                 }
//             }) ?? []
//             searchData[0].value = searchData[0].children[0].id
//             getSearch(searchData)
//         }
//     })
// }

// 动态改变表头
const change = (item) => {
    tableHeaderFn();
};

const getImgArr = (str) => {
    if(!str || str.length === 0) {
        return []
    }
    return JSON.parse(str).map(i => i.url)
}

const offHeighths = () => {
    if (myElementRef.value) {
        state.offsetHeight =
            myElementRef.value?.offsetHeight - 90 - searchBox.value?.offsetHeight;
    }
};

const pageChange = (currentPage) => {

    page.value = currentPage;
    getSearch(searchData)
}

const limitChange = (currentLimit) => {

    limit.value = currentLimit;
    getSearch(searchData)
}

const openAudit = (row) => {
    audit.value.open(row)
}

const openDetail = (row) => {
    detail.value.open(row)
}

onMounted(() => {
    try {
        nextTick(() => {
            offHeighths();
        });
        window.onresize = () => {
            nextTick(() => {
                offHeighths();
            });
        };
        applyLabels();
        tableHeaderFn();
        init();
    } catch { }
});

onUnmounted(() => {
    window.onresize = null;
});

// 查询过来的数据
const getSearch = (params) => {
    const form = listToMap(toRaw(params), { value: 'value', key: 'field' })
    const requestParams = {
        page: page.value,
        limit: limit.value,
        ...form
    }
    state.loading = true
		pageListApi(JSON.stringify(requestParams)).then(res => {
        maxPage.value = res?.maxPage ?? 0;
        state.tableData = res?.data?.map(item => {
            return {
                ...item,
                // status: listToMap(statusOptions, {})[item.status],
            }
        }) ?? []
    }).finally(() => {
		state.loading = false
	})
};

// 表头筛选
const tableHeaderFn = () => {
    state.tableHeader = state.column.filter((v) => {
        if (v.show) {
            return v.show == true;
        } else {
            v.show = false;
        }
    });
};
</script>

<style lang="less" scoped>
.finance_box {
    flex: 1;
    overflow: auto;
    background-color: #fff;
    border-radius: 6px;
    padding: 10px;
    margin-right: 10px;
}

.btn_box {
    height: 40px;
    display: flex;
}

.table_box {
    width: 100%;
}

/deep/.el-button-group .el-button--primary:first-child {
    background-color: #1e6aed;
    border: none;
}

.serBtn {
    margin-left: 10px;
    background-color: #f0f0f0;
    color: #000;
    border: none;
}

.serBtn:hover {
    background-color: #f0f0f0;
    color: #000;
}

.opBtn {
    // margin: 0 !important;
    margin: 0 10px 0 0;
}

.opBtn:hover {
    color: #e6a755;
}

.record-img {
    height: 100px;
    border-radius: 6px;
    object-fit: cover;
    margin-left: 10px;
}
</style>
